import { getAllRoles } from '../api/roles';

const ADD_ALL_ROLES = 'ADD_ALL_ROLES';
const LOADED_ALL_ROLES = 'LOADED_ALL_ROLES';

const INITIAL_STATE = {
  isAllRolesLoaded: false,
  roles: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ALL_ROLES:
      return {
        ...state,
        roles: [...action.payload],
      };
    case LOADED_ALL_ROLES:
      return {
        ...state,
        isAllRolesLoaded: true,
      };
    default:
      return state;
  }
}

export function fetchAllRoles() {
  return async (dispatch) => {
    try {
      const roles = await getAllRoles();

      dispatch({
        type: ADD_ALL_ROLES,
        payload: roles,
      });

      return dispatch({ type: LOADED_ALL_ROLES });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
